import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { LocalizedText, withScopeContext } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { ApplicationState } from '@mews-commander/types';
import { TimeUnit } from '@mews/enums';
import { getServiceTimeUnitPluralKey } from '@mews-commander/legacy-entities/src/utils/serviceTimeUnitLocalization';
import { getServiceTimeUnit } from '@mews-commander/legacy-entities/src/ducks/services';
import { SummaryRow } from '../../SummaryRow';
import { getTimeCount, getServiceReservationsStartUtc, getServiceReservationsEndUtc } from '../../../../../selectors';
import TimeUnitCountBody from './TimeUnitCountBody';

interface OwnProps {
    scope: string;
    serviceId: string;
}

interface StateProps {
    timeUnitKey: Mews.TextKey;
    timeUnit: TimeUnit;
    timeUnitCount: number;
    startUtc?: string;
    endUtc?: string;
}

type TimeUnitCountProps = OwnProps & StateProps;

const TimeUnitCount = ({ timeUnitCount, startUtc, endUtc, timeUnitKey, timeUnit }: TimeUnitCountProps) => (
    <SummaryRow
        label={<LocalizedText textKey={timeUnitKey} />}
        body={
            <TimeUnitCountBody timeUnit={timeUnit} timeUnitCount={timeUnitCount} startUtc={startUtc} endUtc={endUtc} />
        }
    />
);

export default withScopeContext(
    connect(
        createStructuredSelector<ApplicationState, OwnProps, StateProps>({
            timeUnitKey: (state, { serviceId }) =>
                getServiceTimeUnitPluralKey(state, { id: serviceId }) || TextKey.Night,
            timeUnit: (state, { serviceId }) => getServiceTimeUnit(state, { id: serviceId }) || TimeUnit.Day,
            timeUnitCount: getTimeCount,
            startUtc: getServiceReservationsStartUtc,
            endUtc: getServiceReservationsEndUtc,
        })
    )(TimeUnitCount)
);
